import React, { useCallback, useContext, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { obterComanda, obterPedido } from 'api/pedidos/queries';
import { CardapioStorageKeys, useCardapioStorage } from 'storage/cardapio-storage';
import { EfetuarPedidoClienteModel, EfetuarPedidoEnderecoClienteModel, EfetuarPedidoModel, EfetuarPedidoPagamentoModel, EfetuarPedidoPagsModel, EfetuarPedidoProdutoModel, EnumPedidoPagamentoSituacao, EnumTipoPedido } from 'api/cardapio/models/pedido/efetuar-pedido';
import { enviarDadosPedido } from 'api/pedidos/mutations';
import { DadosDelivery, EnumOpcoesDelivery, useAtualizarSacola, useEsvaziarSacola, useObterSacola, useRemoverSacola } from 'storage';
import { PedidoModel } from 'api/cardapio/models/pedido/pedido';
import { isEmpty } from 'lodash';
import { ComandaModel, MesaModel } from 'api/pedidos/models';
import { PessoaModel } from 'api/cardapio/models/pessoa/pessoa-model';
import { guidEmpty } from 'utils/guid-empty';
import { useGetLocalizacaoUsuario } from 'utils';
import { DistanciaModel } from 'api/master/models/distancia/distancia-model';
import { postDistancia } from 'api/master/mutations/distancia/enviar-distancia';
import { usePostMovRegistrar } from 'api/cardapio/queries/mov-pag/post-registrar';
import { MovRegistrarModel } from 'api/cardapio/models/mov-pag/mov-registrar';
import { EnumPagTpTransacao, FinalizadoraModel } from 'api/cardapio/models/finalizadora/finalizadora-model';
import { MovParcelaResponseModel } from 'api/cardapio/models/mov-pag/mov-registrar-response';
import { stringNumeros } from 'utils/string-numeros';
import { removerMascaraDocumento } from 'utils/cpfcnpj-format';
import { CardapioDadosProps } from 'modulos/cardapio/containers/cardapio/cardapio-header/cardapio-header-props';
import { roundTo } from 'utils/round-to';
import { calcPercent } from 'utils/calc-percent';
import { useGetPessoaById } from 'api/cardapio/queries/pessoa/get-pessoa-by-id';
import { EnumTipoProduto, EnumTpProduto, MovSimplesProdutoModel } from 'api/cardapio/models/produto/mov-simples-produto-model';
import { useNotificacoes } from 'components/notificacoes';
import { completarEndereco } from 'utils/completar-endereco';
import { EnumConfigEmpresa } from 'models/enums/enum-config-empresa';
import { ProdutoModel } from 'api/cardapio/models/produto/produto-model';
import { usePostCalcularFrete } from 'api/cardapio/queries/geolocalizacao/calcular-frete';
import { CalcularFreteResultadoModel } from 'api/cardapio/models/geolocalizacao/calcular-frete-resultado-model';
import { useMesaStore } from 'services/store/mesa-store';
import { VariaveisAmbiente } from 'ambiente';
import { EnumDeviceType } from 'ambiente/ambiente-tipos';
import { useMovProd } from 'services/hooks/mov-prod';
import { useEmpresaAtual } from 'services/hooks/empresa';
import { useAcompanharPedidoStore } from 'services/store/acompanhar-pedido';
import { useDadosDeliveryStore } from 'services/store/dados-delivery';

interface SelecionarTransacaoProps {
    finalizadora: FinalizadoraModel,
    valor: number,
    pagamentoAReceber: boolean
}

interface PedidosContextValue {
    pedidoAtual: PedidoModel | null;
    carregandoGetPedido: boolean;
    carregandoCriarPedido: boolean;
    carregandoEfetuarNovaVenda: boolean;
    carregandoRegistrarPix: boolean;
    carregandoHandlePedidoPix: boolean;
    codComanda: string | null;
    cliente: PessoaModel | null;
    dadosPix: MovParcelaResponseModel | undefined;
    tipoPagamento: "interno" | "entrega" | null
    transacao: EfetuarPedidoPagamentoModel | undefined
    carregando: boolean
    getPedido: (comandaId?: string) => Promise<PedidoModel | undefined>;
    setCliente: (value: PessoaModel | null) => void;
    getCliente: () => null | PessoaModel;
    pegarComanda: (codigo: string) => Promise<ComandaModel | null | undefined>;
    setTransacao: (pagamento: EfetuarPedidoPagamentoModel | undefined) => void;
    handleRegistroPix: () => Promise<void>;
    setDadosPix: (value: MovParcelaResponseModel) => void;
    setCodComanda: (value: string | null) => void;
    handlePedido: () => Promise<PedidoModel | undefined>;
    cancelarPedido: () => void;
    addOuAttProdutoEntrega: (enderecoDelivery?: DadosDelivery) => Promise<boolean | undefined>
    removerItemEntregaSacola: () => Promise<void>
    selecionarTpPagamento: (tipo: 'interno' | 'entrega') => void
    selecionarTransacao: (props: SelecionarTransacaoProps) => void
    getItensSacola: () => MovSimplesProdutoModel[],
    getItemEntrega: () => MovSimplesProdutoModel | undefined
    isPedidoDelivery: boolean
    finalizadoraSelecionada: FinalizadoraModel | undefined
    setFinalizadoraSelecionada: React.Dispatch<React.SetStateAction<FinalizadoraModel | undefined>>
    getInfoPedidoLocal: () => {
        mesa: any;
        mesaId: any;
        comanda: string;
    },
    getPedidoAtual: () => Promise<PedidoModel | undefined>
    getClientePadraoWrapper: () => Promise<PessoaModel>
}

const PedidosContext = React.createContext<PedidosContextValue>({
    pedidoAtual: null,
    cliente: null,
    carregandoGetPedido: false,
    carregandoCriarPedido: false,
    carregandoEfetuarNovaVenda: false,
    carregandoRegistrarPix: false,
    carregandoHandlePedidoPix: false,
    codComanda: null,
    getPedido: (comandaId?: string) => new Promise(() => new PedidoModel()),
    setCliente: (value: PessoaModel | null) => { },
    getCliente: (): null | PessoaModel => null,
    pegarComanda: (codigo: string) => new Promise(() => null),
    setTransacao: (pagamento: EfetuarPedidoPagamentoModel | undefined) => { },
    handleRegistroPix: () => new Promise(() => { }),
    dadosPix: undefined,
    setDadosPix: (value: MovParcelaResponseModel) => { },
    setCodComanda: (value: string | null) => { },
    handlePedido: () => new Promise(() => undefined),
    cancelarPedido: () => null,
    addOuAttProdutoEntrega: (enderecoDelivery?: DadosDelivery) => new Promise(() => true),
    removerItemEntregaSacola: () => new Promise(() => { }),
    carregando: false,
    selecionarTpPagamento: (tipo: 'interno' | 'entrega') => { },
    tipoPagamento: null,
    selecionarTransacao: ({ finalizadora, valor, pagamentoAReceber }: SelecionarTransacaoProps) => { },
    transacao: undefined,
    getItensSacola: () => [],
    getItemEntrega: () => undefined,
    isPedidoDelivery: false,
    finalizadoraSelecionada: undefined,
    setFinalizadoraSelecionada: () => { },
    getInfoPedidoLocal: () => ({
        mesa: '',
        mesaId: '',
        comanda: '',
    }),
    getPedidoAtual: () => new Promise(() => undefined),
    getClientePadraoWrapper: () => new Promise(() => undefined),
});

export const usePedidos = () => useContext(PedidosContext);

export interface PedidosProviderProps {
    children: React.ReactNode;
}

export enum EnumStatusProdutoPedido {
    DISPONIVEL = 1,
    INDISPONIVEL = 2,
    DESISTENCIA = 3,
    TROCADO = 4,
}

export const PedidosProvider = ({ children }: PedidosProviderProps) => {

    //HOOKS
    const [esvaziarSacola] = useEsvaziarSacola();
    const { showErrorMessage } = useNotificacoes();
    const { location } = useHistory();
    const mesaStore = useMesaStore(state => state.mesa)
    const { getConfigByCod } = useEmpresaAtual()

    //STORAGE
    const { setRegistro, getRegistro } = useCardapioStorage()


    //STATES E REFS
    const [pedidoAtual, setPedidoAtual] = useState<PedidoModel | null>(null);
    const [carregandoGetPedido, setCarregandoGetPedido] = useState<boolean>(false)
    const [carregandoCriarPedido, setCarregandoCriarPedido] = useState<boolean>(false)
    const [cliente, setCliente] = useState<PessoaModel | null>(null)
    const [codComanda, setCodComanda] = useState<string | null>(null)
    const [transacao, setTransacao] = useState<EfetuarPedidoPagamentoModel | undefined>(undefined)
    const [dadosPix, setDadosPix] = useState<MovParcelaResponseModel>()
    const [carregandoDistancia, setCarregandoDistancia] = useState<boolean>(false)
    const [tipoPagamento, setTipoPagamento] = useState<'interno' | 'entrega' | null>(null)
    const [finalizadoraSelecionada, setFinalizadoraSelecionada] = useState<FinalizadoraModel | undefined>()

    //HOOKS
    const { empresaId } = useParams<{ empresaId: string, mesaId: string }>();
    const { insertCentralizadoProduto } = useMovProd()
    const { postCalcularFrete, carregando: carregandoCalcularFrete } = usePostCalcularFrete()
    const [removerSacolaItemEntrega] = useRemoverSacola({ removerNotificacao: true });
    const [atualizarSacola] = useAtualizarSacola()
    const novoPedido = useAcompanharPedidoStore(state => state.novoPedido)
    const sacola = useObterSacola(empresaId)
    const getPedidoAcompanhamento = useAcompanharPedidoStore(state => state.getPedido)
    const obterPedidoAcompanhamento = getPedidoAcompanhamento(empresaId)

    //CHAMADAS API
    const { obterLocalizacao } = useGetLocalizacaoUsuario();
    const { postMovRegistrar, carregando: carregandoMovRegistrar } = usePostMovRegistrar()
    const { getPessoaById, carregando: carregandoPessoaById } = useGetPessoaById()
    const getMesaId = useMesaStore(state => state.getMesaId)
    const mesaId = getMesaId(location.pathname);

    // AUX
    const dadosGerais = getRegistro(CardapioStorageKeys.DadosGerais, false) as CardapioDadosProps;
    const configCardapio = dadosGerais.configuracoes
    const configDelivery = dadosGerais.configuracoesDelivery
    const dadosEmpresa = dadosGerais.empresa
    const carregando = [carregandoCalcularFrete].includes(true)

    const isPedidoDelivery = !mesaId

    const deliveryHabilitado = (configDelivery?.deliveryHabilitado || false)

    const carregandoEfetuarNovaVenda = [
        carregandoPessoaById,
    ].includes(true)

    const getClientePadraoWrapper = useCallback(async () => {
        const clientePadraoId = getConfigByCod(EnumConfigEmpresa.ClientePadrao)
        const clientePadraoStorage = getRegistro(CardapioStorageKeys.ClientePadrao) as PessoaModel

        if (!isEmpty(clientePadraoStorage) && clientePadraoStorage.id === (clientePadraoId?.valor ?? '')) {
            return clientePadraoStorage
        }
        const res = await getPessoaById(clientePadraoId?.valor ?? '', empresaId)
        if (res.erro) throw res.erro

        setRegistro(CardapioStorageKeys.ClientePadrao, res.resultado?.data)

        return res.resultado?.data as PessoaModel
    }, [empresaId, getConfigByCod, getPessoaById, getRegistro, setRegistro])

    const carregandoRegistrarPix = [carregandoMovRegistrar, carregandoDistancia].includes(true)

    const carregandoHandlePedidoPix = [carregandoCriarPedido].includes(true)

    const getInfoPedidoLocal = useCallback(() => {
        const mesa =
            Object.values(getRegistro(CardapioStorageKeys.MesaAtual, false)).find(x => Boolean(x))
                ? getRegistro(CardapioStorageKeys.MesaAtual, false)
                : mesaStore as MesaModel | null;

        return {
            mesa: mesa?.codigo || '',
            mesaId: mesa?.id || '',
            comanda: codComanda ?? '',
        }
    }, [codComanda, getRegistro, mesaStore])

    const pegarComanda = useCallback(async (codigo: string) => {
        const empresa = getRegistro(CardapioStorageKeys.DadosGerais, false) as CardapioDadosProps
        if (codigo.length > 3) {
            codigo = codigo.slice(codigo.length - 3, codigo.length)
            if (codigo[0] === '0' && codigo[1] === '0') {
                codigo = codigo.slice(codigo.length - 1, codigo.length)
            }
            else if (codigo[0] === '0') {
                codigo = codigo.slice(codigo.length - 2, codigo.length)
            }
        } else {
            if (codigo[0] === '0' && codigo[1] === '0') {
                codigo = codigo.slice(codigo.length - 1, codigo.length)
            }
            else if (codigo[0] === '0') {
                codigo = codigo.slice(codigo.length - 2, codigo.length)
            }
        }

        const ret = await obterComanda.execute(empresa.empresa.id, codigo);
        if (isEmpty(ret)) {
            throw new Error(`Verifique se é um código valido e tente novamente`);
        }
        const comandas = (ret ?? []) as ComandaModel[]

        return comandas.find(x => x.status.codigo === 1) ?? null

    }, [getRegistro])

    const getItensSacola = useCallback(() => {
        return sacola?.data ?? []
    }, [sacola?.data])

    const getPedido = useCallback(async (codComanda?: string) => {
        setCarregandoGetPedido(true)
        setPedidoAtual(null)
        try {
            let res
            let comanda: ComandaModel | null | undefined = null
            if (codComanda) {
                comanda = await pegarComanda(codComanda)

                res = await obterPedido.execute({ empresaId: empresaId, comandaId: comanda?.id });
            } else {
                res = await obterPedido.execute({ empresaId: empresaId, mesaId: mesaId });
            }
            setPedidoAtual(res);
            return res as PedidoModel
        }
        catch (err: any) {
            showErrorMessage(err.message);
        }
        finally {
            setCarregandoGetPedido(false)
        }
    }, [empresaId, mesaId, pegarComanda, showErrorMessage])

    const postDistanciaWrapper = useCallback(async (model: DistanciaModel) => {
        const res = await postDistancia.execute(model, empresaId);

        return res.dentro
    }, [empresaId])

    const prodEntregaParaProdutoModel = useCallback(() => {
        const prodEntrega = configDelivery?.produtoEntrega
        const prodEntregaGrade = prodEntrega?.grades?.[0]
        if (!prodEntrega) {
            return
        }

        const produtoModel: ProdutoModel = {
            ativo: prodEntregaGrade?.ativo ?? false,
            balanca: prodEntregaGrade?.balanca ?? 0,
            categoriaId: prodEntrega.categoriaId ?? '',
            cobraTaxaServico: false,
            codigo: prodEntregaGrade?.codigo ?? '',
            codigos: [],
            contemSubItem: false,
            empresaId: prodEntregaGrade?.empresaId ?? '',
            favorito: false,
            grupoImpostoId: '',
            id: prodEntrega?.id ?? '',
            idGroup: '',
            imagemUrl: '',
            infAdic: prodEntrega?.infAdic ?? '',
            medida: prodEntregaGrade?.medidaEntradaId ?? '',
            medidaDesc: 'UN',
            ncm: '',
            ncmId: prodEntrega?.ncmId ?? '',
            nome: prodEntrega?.nome ?? '',
            prodSubItem: [],
            produtoGradeId: prodEntregaGrade?.id ?? '',
            produtoId: prodEntrega?.id ?? '',
            pTribEstadual: 0,
            pTribFederal: 0,
            pTribManual: 0,
            pTribMunicipal: 0,
            setorId: prodEntrega?.setorId ?? '',
            subItens: [],
            temImposto: false,
            tipo: EnumTipoProduto.Produto,
            vPreco: prodEntregaGrade?.vPreco ?? 0,
            vTrib: 0,
            categoriaDescricao: ''
        }

        return insertCentralizadoProduto(produtoModel, 1, 0, 0, 0, 0, '')
    }, [configDelivery?.produtoEntrega, insertCentralizadoProduto])

    const getTransacaoPags = useCallback((pagamento: EfetuarPedidoPagamentoModel): EfetuarPedidoPagsModel => {
        return {
            bandeira: pagamento.bandeira,
            cAut: pagamento.cAut,
            cnpj: pagamento.cnpj,
            concluido: pagamento.concluido,
            nomeCartao: pagamento.nomeCartao,
            pagamentoId: pagamento.pagamentoId ?? '',
            vPag: pagamento.valorPago,
            vTroco: pagamento.valorTroco,
            nroCartao: pagamento.nroCartao ?? '',
            nsu: pagamento.nsu,
            qtdeParcela: pagamento.qtdeParcela ?? 0,
            status: pagamento.status,
            tefId: pagamento.tefId ?? '',
            tpSolicitado: pagamento.tpSolicitado,
            tpTroco: null,
            mensagem: pagamento.mensagem,
            viaConsumidor: pagamento.viaConsumidor,
            viaEstabelecimento: pagamento.viaEstabelecimento,
        }
    }, [])

    const addOuAttProdutoEntrega = async (enderecoModel?: DadosDelivery) => {
        const enderecoStorage = useDadosDeliveryStore.getState().enderecoDelivery
        const endereco = enderecoModel
        const res = await postCalcularFrete({
            bairro: endereco?.bairro ?? enderecoStorage?.bairro ?? '',
            cep: endereco?.cep ?? enderecoStorage?.cep ?? '',
            cidade: endereco?.municipio ?? enderecoStorage?.xMun ?? '',
            estado: endereco?.uf ?? enderecoStorage?.uf ?? '',
            logradouro: endereco?.lgr ?? enderecoStorage?.logradouro ?? '',
            numero: endereco?.nro ?? enderecoStorage?.numero ?? ''
        }, empresaId)
        if (res.erro) throw res.erro

        const resultado = res.resultado?.data as CalcularFreteResultadoModel

        if (!resultado.dentro) return false
        const prodEntrega = configDelivery?.produtoEntrega
        const itens = sacola.data
        const prodEntregaSacola = (itens ?? []).filter(x => x.produtoId === prodEntrega?.id)
        const valor = resultado.valorFrete

        if ((prodEntregaSacola?.length ?? 0) === 0) {
            const prod = prodEntregaParaProdutoModel()
            if (prod) {
                prod.vFinal = resultado.valorFrete
                prod.vProd = valor
                prod.vUnCom = valor
                prod.vFrete = valor
                await atualizarSacola({ produto: prod, empresaId })
            }
            return true
        }

        const prod = prodEntregaSacola[0]
        prod.vFinal = valor
        prod.vProd = valor
        prod.vUnCom = valor
        prod.vFrete = valor
        await atualizarSacola({ produto: prod, empresaId })
        return true
    }

    const removerItemEntregaSacola = async () => {
        const produtoEntrega = configDelivery?.produtoEntrega
        const prodEntregaId = produtoEntrega?.id
        const itensSacola = sacola?.data ?? []
        const itemEntregaSacola = itensSacola.find(item => item.produtoId === prodEntregaId)

        if (itemEntregaSacola) {
            await removerSacolaItemEntrega({ idProduto: itemEntregaSacola.id, empresaId: empresaId });
        }
    }

    const pedidoProdutosWrapper = useCallback((
        produtosMovSimples: MovSimplesProdutoModel[],
        salaoId: string | null = null,
        isDelivery: boolean = false,
    ) => {
        const taxaRecomendada = getConfigByCod(EnumConfigEmpresa.TaxaServicoRecomendada)

        const produtoSerializados = produtosMovSimples.map((prod) => {
            return {
                setorEmpresaId: null,
                plu: prod.cProd,
                descricao: prod.xProd,
                observacao: prod.observacao,
                pesoVariavel: prod.balanca,
                codigoBarra: prod.cEan,
                status: prod.ativo
                    ? EnumStatusProdutoPedido.DISPONIVEL
                    : EnumStatusProdutoPedido.DESISTENCIA,
                nItem: prod.nSeq,
                posicaoMesa: '',
                codigoReferencia: prod.id,
                quantidade: prod.qComModificador > 0 ? prod.qComModificador : prod.qCom,
                valorTotal: prod.vFinal,
                valorTotalDesconto: prod.vDescUsuario,
                valorUnitario: prod.vUnCom,
                valorTotalAdicional: 0,
                valorTotalFrete: prod.vFrete,
                vendedor: prod.vendedorNome,
                vendedorId: prod.vendedorId,
                setorId: prod.setorId,
                salaoId: salaoId,
                indFin: prod.tpProduto === EnumTpProduto.Combo ? false : prod.indFin,
                groupId: prod.idGroup,
                adicionalId: prod.idAdicional,
                subItens: pedidoProdutosWrapper(prod.prodSubItem, salaoId),
                produtoPai: prod.produtoPaiId,
                tpProduto: prod.tpProduto,
                taxaServico: isDelivery ? 0 : prod.cobraTaxaServico && prod.indFin ? Number(taxaRecomendada?.valor ?? 0) : 0,
                valorTotalServico: isDelivery ? 0 : prod.cobraTaxaServico && prod.indFin ? roundTo(calcPercent(prod?.vFinal ?? 0, Number(taxaRecomendada?.valor ?? 0))) : 0,
                produtoIdReferencia: prod.produtoId,
                quantidadeMax: prod.qCom,
                produtoGradeId: prod.produtoGradeId,
                unidadeComercial: prod.uCom,
            } as unknown;
        }) as EfetuarPedidoProdutoModel[];

        return produtoSerializados;
    }, [getConfigByCod]);

    const criarPedido = useCallback(async () => {
        setCarregandoCriarPedido(true)
        try {
            const { enderecoDelivery, tipoDelivery } = useDadosDeliveryStore.getState()
            let comanda: ComandaModel | null | undefined = null
            const isComanda = codComanda
            const sacola = getItensSacola()
            let finalizar = false

            const mesa =
                Object.values(getRegistro(CardapioStorageKeys.MesaAtual, false)).find(x => Boolean(x))
                    ? getRegistro(CardapioStorageKeys.MesaAtual, false)
                    : mesaStore as MesaModel | null;
            console.log('registroMesa', mesa)
            const pedidos = getRegistro(CardapioStorageKeys.Pedidos, false) as any[]
            console.log('registroPedidos', pedidos)
            let isDelivery = false

            let request: EfetuarPedidoModel = new EfetuarPedidoModel();

            if (codComanda) {
                comanda = await pegarComanda(codComanda)
                console.log('getComanda, comanda')
            }
            if (mesa && !isEmpty(mesa) && mesaId) {
                request.salaoId = mesa.salaoId;
                request.mesaId = mesa.id;
            }

            if (comanda) {
                request.comandaId = comanda.id
            }

            if (!isComanda && !mesaId && deliveryHabilitado) {
                isDelivery = true
                request.tipoPedido =
                    tipoDelivery === EnumOpcoesDelivery.Entrega
                        ? EnumTipoPedido.ENTREGA
                        : EnumTipoPedido.RETIRAR
            }

            const produtosReq: EfetuarPedidoProdutoModel[] = pedidoProdutosWrapper(sacola, mesa?.salaoId, isDelivery)

            if (cliente && !isEmpty(cliente)) {
                request.cliente = new EfetuarPedidoClienteModel();
                request.cliente.razaoSocial = cliente.nome
                request.cliente.nomeFantasia = cliente.nome
                request.cliente.cpfCnpj = removerMascaraDocumento(cliente.cpfcnpj) || undefined
                request.cliente.referenceId = !cliente.id || cliente.id === guidEmpty() ? undefined : cliente.id
                request.cliente.telefone = cliente.contatos.find(x => x.tipo === 0)?.valor ?? ''
                request.cliente.email = cliente.contatos.find(x => x.tipo === 1)?.valor ?? ''
            } else {
                request.cliente = new EfetuarPedidoClienteModel();
                const clientePadrao = await getClientePadraoWrapper()
                request.cliente.razaoSocial = clientePadrao.nome
                request.cliente.nomeFantasia = clientePadrao.nome
                request.cliente.cpfCnpj = removerMascaraDocumento(clientePadrao.cpfcnpj)
                request.cliente.referenceId = !clientePadrao.id ? undefined : clientePadrao.id
                request.cliente.telefone = clientePadrao.contatos.find(x => x.tipo === 0)?.valor ?? ''
                request.cliente.email = clientePadrao.contatos.find(x => x.tipo === 1)?.valor ?? ''
            }

            if (transacao) {
                request.pagamento = {
                    ...transacao
                }
                if ([EnumPagTpTransacao.SAFRA_PIX, EnumPagTpTransacao.SAFRAPAY_WALLET].includes(request.pagamento.tpTransacao) && !isDelivery) {
                    finalizar = true
                }
            }

            if (finalizar === true && transacao) {
                const transacaoPags = getTransacaoPags(transacao)
                request.pags.push(transacaoPags)
            }


            if (!mesaId && deliveryHabilitado && tipoDelivery !== undefined) {
                if (tipoDelivery === EnumOpcoesDelivery.Entrega) {
                    request.enderecoEntrega = {
                        ...new EfetuarPedidoEnderecoClienteModel(),
                        bairro: enderecoDelivery?.bairro ?? '',
                        cep: enderecoDelivery?.cep ?? '',
                        complemento: enderecoDelivery?.complemento ?? '',
                        logradouro: enderecoDelivery?.logradouro ?? '',
                        municipio: enderecoDelivery?.xMun ?? '',
                        numero: enderecoDelivery?.numero ?? '',
                        pontoReferencia: enderecoDelivery?.referencia ?? '',
                        uf: enderecoDelivery?.uf ?? '',
                        enderecoCompleto: completarEndereco(
                            enderecoDelivery?.logradouro ?? '',
                            enderecoDelivery?.numero ?? '',
                            enderecoDelivery?.xMun ?? '',
                            enderecoDelivery?.uf ?? '',
                            enderecoDelivery?.cep ?? ''
                        )
                    }
                }
                else {
                    request.enderecoEntrega = {
                        ...new EfetuarPedidoEnderecoClienteModel(),
                        bairro: dadosEmpresa?.bairro ?? '',
                        cep: dadosEmpresa?.cep ?? '',
                        complemento: dadosEmpresa?.complemento ?? '',
                        logradouro: dadosEmpresa?.logradouro ?? '',
                        municipio: dadosEmpresa?.municipio ?? '',
                        numero: dadosEmpresa?.numero || '0',
                        pontoReferencia: '',
                        uf: dadosEmpresa?.uf,
                        enderecoCompleto: completarEndereco(dadosEmpresa.logradouro, dadosEmpresa.numero, dadosEmpresa.municipio, dadosEmpresa.uf, dadosEmpresa.cep)
                    }
                }
            }

            request.finalizar = finalizar

            request.produtos = produtosReq;

            const distanciaMaxima = configCardapio?.distanciaMaxima

            if (mesaId && VariaveisAmbiente.deviceType !== EnumDeviceType.CORDOVA && distanciaMaxima !== -1) {
                console.log('tentando localização')

                console.log('tentando distância')
                const localizacao = await obterLocalizacao();
                console.log('localizacao', localizacao)
                const resposta = await postDistanciaWrapper(localizacao);
                console.log('respostaDistancia', resposta)

                if (!resposta) {
                    setCarregandoDistancia(false)
                    throw new Error('Você saiu do raio definido pelo dono da loja. Volte para a loja ou cancele o pedido.')
                }
            }

            console.log('tentando enviar pedido')
            const resPedido: PedidoModel = await enviarDadosPedido.execute(request, empresaId);
            console.log('enviou pedido', resPedido)
            if (resPedido && isDelivery) {
                novoPedido(resPedido.id, empresaId)
            }

            esvaziarSacola({ empresaId: empresaId });
            setTransacao(undefined)
            setCodComanda(null)
            setCliente(null)
            setDadosPix(undefined)
            await getPedido();
            return resPedido
        }
        finally {
            setCarregandoCriarPedido(false)
        }
    }, [codComanda, getItensSacola, getRegistro, mesaStore, mesaId, deliveryHabilitado, pedidoProdutosWrapper, cliente, transacao, configCardapio?.distanciaMaxima, empresaId, esvaziarSacola, getPedido, pegarComanda, getClientePadraoWrapper, getTransacaoPags, dadosEmpresa?.bairro, dadosEmpresa?.cep, dadosEmpresa?.complemento, dadosEmpresa?.logradouro, dadosEmpresa?.municipio, dadosEmpresa?.numero, dadosEmpresa?.uf, obterLocalizacao, postDistanciaWrapper, novoPedido]);

    const getCliente = useCallback(() => cliente, [cliente])

    const handleRegistroPix = useCallback(async (): Promise<void> => {
        const registrar: MovRegistrarModel = new MovRegistrarModel()
        const produtos = getRegistro(CardapioStorageKeys.Sacola, false) as MovSimplesProdutoModel[];

        setCarregandoDistancia(true)

        if (mesaId) {
            const localizacao = await obterLocalizacao();

            const resposta = await postDistanciaWrapper(localizacao);

            if (!resposta) {
                setCarregandoDistancia(false)
                throw new Error('Você saiu do raio definido pelo dono da loja. Volte para a loja ou cancele o pedido.')
            }
        }
        setCarregandoDistancia(false)

        const finalizadoras = dadosGerais.finalizadoras as FinalizadoraModel[]
        const pixFinalizador = transacao

        if (finalizadoras.length === 0 || isEmpty(finalizadoras)) {
            throw new Error('Forma de pagamento não foi configurada corretamente ou não implementada.')
        }

        registrar.finalizadoraId = pixFinalizador?.pagamentoId ?? guidEmpty()
        registrar.valor = produtos.reduce((a, b) => a + b.vFinal, 0)

        registrar.pagador = {
            cpfCnpj: removerMascaraDocumento(cliente?.cpfcnpj ?? ''),
            fone: stringNumeros(cliente?.contatos.find(x => x.tipo === 0)?.valor ?? ''),
            email: cliente?.contatos.find(x => x.tipo === 1)?.valor ?? '',
            nome: cliente?.nome ?? 'Consumidor'
        }

        const res = await postMovRegistrar(registrar, dadosGerais.empresa?.id)
        if (res.erro) throw res.erro

        setDadosPix(res.resultado?.data?.parcelas[0])
    }, [cliente?.contatos, cliente?.cpfcnpj, cliente?.nome, dadosGerais.empresa?.id, dadosGerais.finalizadoras, getRegistro, mesaId, obterLocalizacao, postDistanciaWrapper, postMovRegistrar, transacao])

    const handlePedido = useCallback(async () => {
        const res = await criarPedido()
        return res
    }, [criarPedido])

    const cancelarPedido = useCallback(() => {
        esvaziarSacola({ empresaId: empresaId });
        setTransacao(undefined)
        setCodComanda(null)
        setCliente(null)
        setDadosPix(undefined)
    }, [empresaId, esvaziarSacola])

    const selecionarTpPagamento = useCallback((tpPagamento: 'interno' | 'entrega') => {
        setTipoPagamento(tpPagamento)
    }, [setTipoPagamento])

    const selecionarTransacao = useCallback(({ finalizadora, valor, pagamentoAReceber }: SelecionarTransacaoProps) => {
        const produtos = getRegistro(CardapioStorageKeys.Sacola, false) as MovSimplesProdutoModel[];
        const valorTotalProdutos = produtos.reduce((a, b) => a + b.vFinal, 0);
        const valorTroco = valor - valorTotalProdutos;

        const ajustarTransacao: EfetuarPedidoPagamentoModel = {
            ...new EfetuarPedidoPagamentoModel(),
            referenceId: finalizadora.id,
            situacao: EnumPedidoPagamentoSituacao.APROVADO,
            valorPago: valor,
            valorTroco: valorTroco,
            pagamentoDescricao: finalizadora.descricao,
            tpMod: finalizadora.tpMod,
            pagamentoAReceber: pagamentoAReceber,
            pagamentoPessoa: cliente?.nome ?? 'Consumidor',
            transacoes: [],
            id: guidEmpty(),
            pagamentoId: finalizadora.id,
            tpTransacao: finalizadora.tpTransacao,
        }

        setTransacao(ajustarTransacao)
    }, [cliente?.nome, getRegistro])

    const getItemEntrega = useCallback(() => {
        const itens = getItensSacola()
        const prodEntregaId = configDelivery.produtoEntrega?.id
        return itens?.find(x => x.produtoId === prodEntregaId)
    }, [configDelivery?.produtoEntrega?.id, getItensSacola])

    const getPedidoAtual = useCallback(async () => {
        try {
            setCarregandoGetPedido(true)
            const pedidoId = obterPedidoAcompanhamento?.id
            if (isEmpty(pedidoId)) return
            const res = await obterPedido.execute({ empresaId: empresaId, pedidoId });
            if (isEmpty(res)) return

            return res as PedidoModel
        } catch (err: any) {
            console.log(err)
        } finally {
            setCarregandoGetPedido(false)
        }
    }, [empresaId, obterPedidoAcompanhamento?.id])

    return (
        <PedidosContext.Provider
            value={{
                // VARIÁVEIS
                pedidoAtual,
                carregandoCriarPedido,
                carregandoGetPedido,
                carregandoEfetuarNovaVenda,
                carregandoRegistrarPix,
                carregandoHandlePedidoPix,
                dadosPix,
                cliente,
                codComanda,
                carregando,
                tipoPagamento,
                transacao,
                isPedidoDelivery,
                finalizadoraSelecionada,

                // FUNÇÕES
                getPedido,
                setCliente,
                getCliente,
                pegarComanda,
                setTransacao,
                handleRegistroPix,
                setDadosPix,
                setCodComanda,
                handlePedido,
                cancelarPedido,
                addOuAttProdutoEntrega,
                removerItemEntregaSacola,
                selecionarTpPagamento,
                selecionarTransacao,
                getItensSacola,
                getItemEntrega,
                setFinalizadoraSelecionada,
                getInfoPedidoLocal,
                getPedidoAtual,
                getClientePadraoWrapper,
            }}>
            {children}
        </PedidosContext.Provider>
    );
};
